import React from "react";
import "./OwnerSection.scss";
import Owner1 from "../../Images/owner1.png";
// import Owner2 from "../../Images/owner2.png";
import Owner2 from "../../Images/1.gif";
import Owner3 from "../../Images/owner3.png";
import Owner4 from "../../Images/owner4.png";
import Owner5 from "../../Images/owner5.png";
// import Owner6 from "../../Images/owner6.png";
import Owner6 from "../../Images/2.gif";
import { Container, Row } from "react-bootstrap";
import trusted from "../../Images/trusted.png";
import topright from "../../Images/topright.png";
const OwnerSection = () => {
  return (
    <Container>
      {/* <div className="owner_section_main_wrapper">
        <div className="owner_section_first_wrapper">
          <img src={Owner1} />
        </div>
        <div className="owner_section_second_wrapper">
          <div className="inside_second_wrapper">
            The <span>owner</span> of the <span>restaurant</span> will meet you.
          </div>
        </div>
        <div className="owner_section_third_wrapper">
          <img src={Owner2} />
        </div>
      </div> */}
       
        <div className="gallery-container">
          {/* <div className="ownertop">
            <div className="owner1"> 
              <img src={Owner1} alt=""/>
            </div>
            <div className="owner2">
              <img src={Owner4} alt=""/>
            </div>
          </div>
          <div className="ownermiddle">
            <div className="owner3">
              <img src={Owner2} alt="" />
            </div>
            <div className="owner4">
              <img src={Owner6} alt=""/>
            </div>
          </div>
          <div className="ownerbottom">
            <div className="owner5">
              <img src={Owner3} alt=""/>
            </div>
            <div className="owner6">
              <img src={Owner5} alt=""/>
            </div>
          </div> */}
          <div className="content">
              <h2>
                Trusted by
              </h2>
              <h2><span>10 Lakh +</span> Restaurant <span>Owners Globally</span></h2>
          </div>
          <div className="imgbox">
            <img src={trusted} alt="Trust image" className="trustedImg" />
            <img src={topright} alt="Top right image" className="toprightImg" />
          </div>
          {/* <img src={Owner1} alt="Image 1" className="gallery-item top-left" />
          <img src={Owner2} alt="Image 2" className="gallery-item bottom-left" />
          <img src={Owner3} alt="Image 3" className="gallery-item top-right" />
          <img src={Owner4} alt="Image 4" className="gallery-item bottom-right" />
          <img src={Owner5} alt="Image 5" className="gallery-item center-left" />
          <img src={Owner6} alt="Image 5" className="gallery-item center-left" />
          <div className="gallery-text">
            <p>The <span className="highlight-red">owner</span> of the <span className="highlight-red">restaurant</span> will meet you.</p>
          </div> */}
        </div>
      </Container>
    
  );
};

export default OwnerSection;
